import { useEffect } from 'react';

import { useGetQuestionnaireV3 } from 'services/profile/hooks';
import Loader from 'components/Loader';
import { QUESTIONNAIRE_CODE } from 'lib/constants';
import BodyComplexion from '../BodyComplexion';
import { useQuestionnaireStore } from 'store/questionnaire';
import QuestionnaireWrapper from './QuestionnaireWrapper';
import FitnessLevel from '../FitnessLevel';
import SleepLevel from '../SleepLevel';
import SleepQuality from '../SleepQuality';
import StressLevels from '../StressLevels';
import EatingHabits from '../EatingHabits';
import WaterConsumption from '../WaterConsumption';
import AlcoholConsumption from '../AlcoholConsumption';
import Smoking from '../Smoking';
import MedicalCondition from '../MedicalCondition';
import FamilyMedicalCondition from '../FamilyMedicalCondition';
import Allergies from '../Allergies';
import Medications from '../Medications';
import SpecifyMedicalCondition from '../SpecifyMedicalCondition';
import Surgery from '../Surgery';
import SpecifyMedications from '../SpecifyMedications';
import { useSearchParams } from 'react-router-dom';
import useAuthStore from 'store/auth';
import useRiskCheckerStore from 'store/risk-checker';

export default function QuestionnairePage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  const profileId = useAuthStore((store) => store.currentUserProfileId);
  const questionData = useQuestionnaireStore((store) => store.questionData);
  const setEngineName = useRiskCheckerStore((store) => store.setEngineName);
  const setQuestionData = useQuestionnaireStore(
    (store) => store.setQuestionData
  );
  const { data, isLoading } = useGetQuestionnaireV3({
    payload: { type: 'latest', profileId },
    enabled: !code,
  });

  const question = data?.data[0];

  useEffect(() => {
    if (!question) return;

    setQuestionData(question);
  }, [question]);

  useEffect(() => {
    return () => {
      setQuestionData(undefined);
    };
  }, []);

  useEffect(() => {
    setEngineName(null);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (!questionData) {
    // return <Navigate to={PATH_ROUTES.PROFILE} />;
    return null;
  }

  const renderQuestion = () => {
    switch (questionData.code) {
      case QUESTIONNAIRE_CODE.BODY_TYPE:
        return <BodyComplexion />;
      case QUESTIONNAIRE_CODE.FITNESS_LEVEL:
        return <FitnessLevel />;
      case QUESTIONNAIRE_CODE.SLEEP_LEVEL:
        return <SleepLevel />;
      case QUESTIONNAIRE_CODE.SLEEP_QUALITY:
        return <SleepQuality />;
      case QUESTIONNAIRE_CODE.STRESS_LEVELS:
        return <StressLevels />;
      case QUESTIONNAIRE_CODE.EATING_HABITS:
        return <EatingHabits />;
      case QUESTIONNAIRE_CODE.WATER_CONSUMPTION:
        return <WaterConsumption />;
      case QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION:
        return <AlcoholConsumption />;
      case QUESTIONNAIRE_CODE.SMOKING:
        return <Smoking />;
      case QUESTIONNAIRE_CODE.MEDICAL_CONDITIONS:
        return <MedicalCondition />;
      case QUESTIONNAIRE_CODE.SPECIFY_MEDICAL_CONDITION:
        return <SpecifyMedicalCondition />;
      case QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS:
        return <FamilyMedicalCondition />;
      case QUESTIONNAIRE_CODE.ONGOING_ALLERGIES:
        return <Allergies />;
      case QUESTIONNAIRE_CODE.SURGERY:
        return <Surgery />;
      case QUESTIONNAIRE_CODE.TAKING_MEDICATIONS:
        return <Medications />;
      case QUESTIONNAIRE_CODE.SPECIFY_MEDICATION:
        return <SpecifyMedications />;
      default:
        return null;
    }
  };

  return <QuestionnaireWrapper>{renderQuestion()}</QuestionnaireWrapper>;
}
